module.exports = __webpack_public_path__ + "static/media/Round2 - img2.487ef805.jpg";